import {
	createElement,
	type HTMLAttributes,
	type PropsWithChildren,
	useId
} from 'react'

/**
 * Imitate `<fieldset>` and `<legend>` but without reset styles
 */
export function FieldSet({
	children,
	legend,
	legendCN,
	level = 'h2',
	...props
}: Omit<HTMLAttributes<HTMLElement>, 'aria-labelledby' | 'role'> &
	PropsWithChildren<{
		legend: string
		legendCN?: string
		level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
	}>) {
	const id = useId()
	return (
		<section aria-labelledby={id} role='group' {...props}>
			{createElement(level, { className: legendCN, id }, legend)}
			{children}
		</section>
	)
}
